export class Partner {
  companyLogo: string;
  companyName: string;
}
